import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'

import { App } from 'components'
import { rootStore, history } from 'reduxModules/configureStore'

const app = (
  <Provider store={rootStore}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>
);


ReactDOM.render(app, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js